import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PackageNotificationsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never; }>;


export type PackageNotificationsQueryResult = (
  { __typename?: 'Query' }
  & { getPackageNotifications: Array<(
    { __typename?: 'PackageNotification' }
    & Pick<GraphQLTypes.PackageNotification, 'id' | 'counterPartyName' | 'counterPartyType' | 'packageId' | 'date' | 'remaining' | 'type' | 'paymentId'>
  )> }
);


export const PackageNotificationsDocument = /*#__PURE__*/ gql`
    query packageNotifications {
  getPackageNotifications {
    id
    counterPartyName
    counterPartyType
    packageId
    date
    remaining
    type
    paymentId
  }
}
    `;

/**
 * __usePackageNotificationsQuery__
 *
 * To run a query within a React component, call `usePackageNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePackageNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<PackageNotificationsQueryResult, PackageNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageNotificationsQueryResult, PackageNotificationsQueryVariables>(PackageNotificationsDocument, options);
      }
export function usePackageNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageNotificationsQueryResult, PackageNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageNotificationsQueryResult, PackageNotificationsQueryVariables>(PackageNotificationsDocument, options);
        }
export type PackageNotificationsQueryHookResult = ReturnType<typeof usePackageNotificationsQuery>;
export type PackageNotificationsLazyQueryHookResult = ReturnType<typeof usePackageNotificationsLazyQuery>;